module.exports = __webpack_public_path__ + "static/07-e1676c308b38219b0f6985542f7f7173.jpg";